import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

export function populateFormArray<T>(
  formArray: FormArray,
  items: T[],
  createFn: (item: T) => FormGroup
): void {
  formArray.clear();
  items.forEach(item => formArray.push(createFn(item)));
}

export function hasAnyValue(control: AbstractControl): boolean {
  if (!control) return false;

  if (control instanceof FormArray) {
    return control.controls.some(ctrl => hasAnyValue(ctrl));
  }

  if (control instanceof FormGroup) {
    return Object.values(control.controls).some(ctrl => hasAnyValue(ctrl));
  }

  const value = control.value;

  return value !== null && value !== '';
}

export function setAllAsRequired(
  control: AbstractControl,
  ignoreKeys: string[] = [],
  controlName?: string
): void {
  if (control instanceof FormArray) {
    control.controls.forEach(ctrl =>
      setAllAsRequired(ctrl, ignoreKeys)
    );
    control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    return;
  }

  if (control instanceof FormGroup) {
    Object.entries(control.controls).forEach(([key, ctrl]) =>
      setAllAsRequired(ctrl, ignoreKeys, key)
    );
    control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    return;
  }

  if (controlName && ignoreKeys.includes(controlName)) {
    return;
  }

  control.setValidators([Validators.required]);
  control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
}

export function removeRequired(control: AbstractControl): void {
  if (control instanceof FormArray) {
    control.controls.forEach(ctrl => removeRequired(ctrl));
    control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    return;
  }

  if (control instanceof FormGroup) {
    Object.values(control.controls).forEach(ctrl => removeRequired(ctrl));
    control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    return;
  }

  if (control instanceof FormControl) {
    control.clearValidators();
    control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
  }
}
